import { useIgnoreAuth } from '@lib/hooks/useIgnoreAuth';
import { signIn, useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { FunctionComponent, useEffect } from 'react';

const AuthHandler: FunctionComponent = () => {
  const router = useRouter();
  const { data: session, status } = useSession();
  const { preventSignIn } = useIgnoreAuth();

  useEffect(() => {
    if (status !== 'loading' && status !== 'authenticated' && !preventSignIn) {
      signIn('da', { callbackUrl: router.asPath });
    }
  }, [router.asPath, session, status, preventSignIn]);

  return null;
};

export default AuthHandler;
